import '../assets/NcBreadcrumbs-E-TglkuV.css';
import { N as L } from "./NcActions-DiFslXqv.mjs";
import y from "../Components/NcActionButton.mjs";
import O from "../Components/NcActionRouter.mjs";
import B from "../Components/NcActionLink.mjs";
import { N as w } from "./NcBreadcrumb-BxCf2hEA.mjs";
import p from "vue";
import { subscribe as W, unsubscribe as N } from "@nextcloud/event-bus";
import { n as g } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import R from "debounce";
import { Fragment as z } from "vue-frag";
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const b = (t, e, s) => {
  if (t !== void 0)
    for (let r = t.length - 1; r >= 0; r--) {
      const a = t[r], i = !a.componentOptions && a.tag && e.indexOf(a.tag) === -1, n = !!a.componentOptions && typeof a.componentOptions.tag == "string", c = n && e.indexOf(a.componentOptions.tag) === -1;
      (i || !n || c) && ((i || c) && p.util.warn("".concat(i ? a.tag : a.componentOptions.tag, " is not allowed inside the ").concat(s.$options.name, " component"), s), t.splice(r, 1));
    }
}, D = {
  name: "FolderIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var I = function() {
  var e = this, s = e._self._c;
  return s("span", e._b({ staticClass: "material-design-icon folder-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(r) {
    return e.$emit("click", r);
  } } }, "span", e.$attrs, !1), [s("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [s("path", { attrs: { d: "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z" } }, [e.title ? s("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, C = [], x = /* @__PURE__ */ g(
  D,
  I,
  C,
  !1,
  null,
  null,
  null,
  null
);
const A = x.exports, o = "vue-crumb", E = {
  name: "NcBreadcrumbs",
  components: {
    NcActions: L,
    NcActionButton: y,
    NcActionRouter: O,
    NcActionLink: B,
    NcBreadcrumb: w,
    IconFolder: A
  },
  props: {
    /**
     * Set a css icon-class for the icon of the root breadcrumb to be used.
     */
    rootIcon: {
      type: String,
      default: "icon-home"
    },
    /**
     * Set the aria-label of the nav element.
     */
    ariaLabel: {
      type: String,
      default: null
    }
  },
  emits: ["dropped"],
  data() {
    return {
      /**
       * Array to track the hidden breadcrumbs by their index.
       * Comparing two crumbs somehow does not work, so we use the indices.
       */
      hiddenIndices: [],
      /**
       * This is the props of the middle Action menu
       * that show the ellipsised breadcrumbs
       */
      menuBreadcrumbProps: {
        // Don't show a name for this breadcrumb, only the Actions menu
        name: "",
        forceMenu: !0,
        // Don't allow dropping directly on the actions breadcrumb
        disableDrop: !0,
        // Is the menu open or not
        open: !1
      },
      breadcrumbsRefs: {}
    };
  },
  beforeMount() {
    b(this.$slots.default, ["NcBreadcrumb"], this);
  },
  beforeUpdate() {
    b(this.$slots.default, ["NcBreadcrumb"], this);
  },
  created() {
    window.addEventListener("resize", R(() => {
      this.handleWindowResize();
    }, 100)), W("navigation-toggled", this.delayedResize);
  },
  mounted() {
    this.handleWindowResize();
  },
  updated() {
    this.delayedResize(), this.$nextTick(() => {
      this.hideCrumbs();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize), N("navigation-toggled", this.delayedResize);
  },
  methods: {
    /**
     * Close the actions menu
     *
     * @param {object} e The event
     */
    closeActions(t) {
      this.$refs.actionsBreadcrumb.$el.contains(t.relatedTarget) || (this.menuBreadcrumbProps.open = !1);
    },
    /**
     * Call the resize function after a delay
     */
    async delayedResize() {
      await this.$nextTick(), this.handleWindowResize();
    },
    /**
     * Check the width of the breadcrumb and hide breadcrumbs
     * if we overflow otherwise.
     */
    handleWindowResize() {
      var l;
      if (!this.$refs.container)
        return;
      const t = Object.values(this.breadcrumbsRefs), e = t.length, s = [], r = this.$refs.container.offsetWidth;
      let a = this.getTotalWidth(t);
      this.$refs.breadcrumb__actions && (a += this.$refs.breadcrumb__actions.offsetWidth);
      let i = a - r;
      i += i > 0 ? 64 : 0;
      let n = 0;
      const c = Math.floor(e / 2);
      for (; i > 0 && n < e - 2; ) {
        const d = c + (n % 2 ? n + 1 : n) / 2 * Math.pow(-1, n + e % 2);
        i -= this.getWidth((l = t[d]) == null ? void 0 : l.elm, d === t.length - 1), s.push(d), n++;
      }
      this.arraysEqual(this.hiddenIndices, s.sort((d, u) => d - u)) || (this.hiddenIndices = s);
    },
    /**
     * Checks if two arrays are equal.
     * Only works for primitive arrays, but that's enough here.
     *
     * @param {Array} a The first array
     * @param {Array} b The second array
     * @return {boolean} Wether the arrays are equal
     */
    arraysEqual(t, e) {
      if (t.length !== e.length)
        return !1;
      if (t === e)
        return !0;
      if (t === null || e === null)
        return !1;
      for (let s = 0; s < t.length; ++s)
        if (t[s] !== e[s])
          return !1;
      return !0;
    },
    /**
     * Calculates the total width of all breadcrumbs
     *
     * @param {Array} breadcrumbs All breadcrumbs
     * @return {number} The total width
     */
    getTotalWidth(t) {
      return t.reduce((e, s, r) => e + this.getWidth(s == null ? void 0 : s.elm, r === t.length - 1), 0);
    },
    /**
     * Calculates the width of the provided element
     *
     * @param {object} el The element
     * @param {boolean} isLast Is this the last crumb
     * @return {number} The width
     */
    getWidth(t, e) {
      if (!(t != null && t.classList))
        return 0;
      const s = t.classList.contains("".concat(o, "--hidden"));
      t.style.minWidth = "auto", e && (t.style.maxWidth = "210px"), t.classList.remove("".concat(o, "--hidden"));
      const r = t.offsetWidth;
      return s && t.classList.add("".concat(o, "--hidden")), t.style.minWidth = "", t.style.maxWidth = "", r;
    },
    /**
     * Prevents the default of a provided event
     *
     * @param {object} e The event
     * @return {boolean}
     */
    preventDefault(t) {
      return t.preventDefault && t.preventDefault(), !1;
    },
    /**
     * Handles the drag start.
     * Prevents a breadcrumb from being draggable.
     *
     * @param {object} e The event
     * @return {boolean}
     */
    dragStart(t) {
      return this.preventDefault(t);
    },
    /**
     * Handles when something is dropped on the breadcrumb.
     *
     * @param {object} e The drop event
     * @param {string} path The path of the breadcrumb
     * @param {boolean} disabled Whether dropping is disabled for this breadcrumb
     * @return {boolean}
     */
    dropped(t, e, s) {
      return s || this.$emit("dropped", t, e), this.menuBreadcrumbProps.open = !1, document.querySelectorAll(".".concat(o)).forEach((a) => {
        a.classList.remove("".concat(o, "--hovered"));
      }), this.preventDefault(t);
    },
    /**
     * Handles the drag over event
     *
     * @param {object} e The drag over event
     * @return {boolean}
     */
    dragOver(t) {
      return this.preventDefault(t);
    },
    /**
     * Handles the drag enter event
     *
     * @param {object} e The drag over event
     * @param {boolean} disabled Whether dropping is disabled for this breadcrumb
     */
    dragEnter(t, e) {
      if (!e && t.target.closest) {
        const s = t.target.closest(".".concat(o));
        s.classList && s.classList.contains(o) && (document.querySelectorAll(".".concat(o)).forEach((a) => {
          a.classList.remove("".concat(o, "--hovered"));
        }), s.classList.add("".concat(o, "--hovered")));
      }
    },
    /**
     * Handles the drag leave event
     *
     * @param {object} e The drag leave event
     * @param {boolean} disabled Whether dropping is disabled for this breadcrumb
     */
    dragLeave(t, e) {
      if (!e && !t.target.contains(t.relatedTarget) && t.target.closest) {
        const s = t.target.closest(".".concat(o));
        if (s.contains(t.relatedTarget))
          return;
        s.classList && s.classList.contains(o) && s.classList.remove("".concat(o, "--hovered"));
      }
    },
    /**
     * Check for each crumb if we have to hide it and
     * add it to the array of all crumbs.
     */
    hideCrumbs() {
      Object.values(this.breadcrumbsRefs).forEach((e, s) => {
        var r;
        (r = e == null ? void 0 : e.elm) != null && r.classList && (this.hiddenIndices.includes(s) ? e.elm.classList.add("".concat(o, "--hidden")) : e.elm.classList.remove("".concat(o, "--hidden")));
      });
    },
    isBreadcrumb(t) {
      var e;
      return (((e = t == null ? void 0 : t.componentOptions) == null ? void 0 : e.tag) || (t == null ? void 0 : t.tag) || "").includes("NcBreadcrumb");
    }
  },
  /**
   * The render function to display the component
   *
   * @param {Function} h The function to create VNodes
   * @return {object|undefined} The created VNode
   */
  render(t) {
    const e = [];
    if (this.$slots.default.forEach((i) => {
      var n, c;
      if (this.isBreadcrumb(i)) {
        e.push(i);
        return;
      }
      (i == null ? void 0 : i.type) === z && ((c = (n = i == null ? void 0 : i.children) == null ? void 0 : n.forEach) == null || c.call(n, (l) => {
        this.isBreadcrumb(l) && e.push(l);
      }));
    }), e.length === 0)
      return;
    p.set(e[0].componentOptions.propsData, "icon", this.rootIcon), p.set(e[0].componentOptions.propsData, "ref", "breadcrumbs");
    const s = {};
    e.forEach((i, n) => {
      p.set(i, "ref", "crumb-".concat(n)), s[n] = i;
    });
    let r = [];
    if (!this.hiddenIndices.length)
      r = e;
    else {
      r = e.slice(0, Math.round(e.length / 2)), r.push(
        t("NcBreadcrumb", {
          class: "dropdown",
          props: this.menuBreadcrumbProps,
          attrs: {
            // Hide the dropdown menu from screen-readers,
            // since the crumbs in the menu are still in the list.
            "aria-hidden": !0
          },
          // Add a ref to the Actions menu
          ref: "actionsBreadcrumb",
          key: "actions-breadcrumb-1",
          // Add handlers so the Actions menu opens on hover
          nativeOn: {
            dragstart: this.dragStart,
            dragenter: () => {
              this.menuBreadcrumbProps.open = !0;
            },
            dragleave: this.closeActions
          },
          on: {
            // Make sure we keep the same open state
            // as the Actions component
            "update:open": (n) => {
              this.menuBreadcrumbProps.open = n;
            }
          }
          // Add all hidden breadcrumbs as ActionRouter or ActionLink
        }, this.hiddenIndices.filter((n) => n <= e.length - 1).map((n) => {
          const c = e[n], l = c.componentOptions.propsData.to, d = c.componentOptions.propsData.href, u = c.componentOptions.propsData.disableDrop, _ = c.componentOptions.propsData.title, $ = c.componentOptions.propsData.name;
          let m = "NcActionButton", f = "";
          d && (m = "NcActionLink", f = d), l && (m = "NcActionRouter", f = l);
          const v = t("IconFolder", {
            props: {
              size: 20
            },
            slot: "icon"
          });
          return t(
            m,
            {
              class: o,
              props: {
                href: d || null,
                title: _,
                to: l || null
              },
              // Prevent the breadcrumbs from being draggable
              attrs: {
                draggable: !1
              },
              on: {
                ...c.componentOptions.listeners
              },
              // Add the drag and drop handlers
              nativeOn: {
                dragstart: this.dragStart,
                drop: (h) => this.dropped(h, f, u),
                dragover: this.dragOver,
                dragenter: (h) => this.dragEnter(h, u),
                dragleave: (h) => this.dragLeave(h, u)
              }
            },
            [v, $]
          );
        }))
      );
      const i = e.slice(Math.round(e.length / 2));
      r = r.concat(i);
    }
    const a = [t("nav", { attrs: { "aria-label": this.ariaLabel } }, [t("ul", { class: "breadcrumb__crumbs" }, [r])])];
    return this.$slots.actions && a.push(t("div", { class: "breadcrumb__actions", ref: "breadcrumb__actions" }, this.$slots.actions)), this.breadcrumbsRefs = s, t("div", { class: ["breadcrumb", { "breadcrumb--collapsed": this.hiddenIndices.length === e.length - 2 }], ref: "container" }, a);
  }
}, S = null, k = null;
var F = /* @__PURE__ */ g(
  E,
  S,
  k,
  !1,
  null,
  "959b70c1",
  null,
  null
);
const J = F.exports;
export {
  J as N
};
